module.exports = __webpack_public_path__ + "img/ic_flag_france.1bb77ced.svg";